import { render, staticRenderFns } from "./prizeList.vue?vue&type=template&id=713966a2&scoped=true&"
import script from "./prizeList.vue?vue&type=script&lang=ts&"
export * from "./prizeList.vue?vue&type=script&lang=ts&"
import style0 from "./prizeList.vue?vue&type=style&index=0&id=713966a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713966a2",
  null
  
)

export default component.exports